import { ShieldCheck, Server, Lock, KeyRound } from "lucide-react";

const KPIS = [
  { value: "10+", suffix: "", label: "Jahre Erfahrung" },
  { value: "110", suffix: "Mio.+", label: "optimierte Kilometer" },
  { value: "15", suffix: "Mio.+", label: "optimierte Sendungen" },
  { value: "900", suffix: "k+", label: "geplante Fahrzeuge" },
];

const BADGES = [
  { icon: ShieldCheck, label: "DSGVO-konform" },
  { icon: Server, label: "Hosted in DE/EU" },
  
  { icon: KeyRound, label: "Ende-zu-Ende SSL/TLS" },
];



export function TrustBar() {
  return (
    <section className="relative isolate overflow-hidden bg-rich-black py-20 md:py-28">
      <div className="absolute inset-0 bg-dot-grid-dark opacity-30 pointer-events-none" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(50% 60% at 50% 0%, hsl(var(--smartlane-orange) / 0.10), transparent 70%)",
        }}
      />

      <div className="container-wide relative">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <p className="eyebrow mb-4">Proof · Trust · Compliance</p>
          <h2 className="text-display-md text-white">
            Verlässlich. Sicher. <span className="text-smartlane-orange">Made in Germany.</span>
          </h2>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-lg overflow-hidden">
          {KPIS.map((kpi) => (
            <div
              key={kpi.label}
              className="group relative bg-rich-black px-6 py-8 md:py-12 text-center transition-colors duration-300 hover:bg-white/[0.03]"
            >
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-display-lg text-white leading-none">{kpi.value}</span>
                {kpi.suffix && (
                  <span className="font-heading text-3xl md:text-4xl text-smartlane-orange leading-none">
                    {kpi.suffix}
                  </span>
                )}
              </div>
              <p className="copy mt-3 text-sm md:text-base text-white/60 uppercase tracking-wider">
                {kpi.label}
              </p>
              <div className="absolute inset-x-8 bottom-0 h-px bg-linear-to-r from-transparent via-smartlane-orange/0 to-transparent group-hover:via-smartlane-orange/60 transition-all duration-500" />
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-12 md:mt-16 flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {BADGES.map((b) => (
            <div
              key={b.label}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/5 border border-white/10 hover:border-smartlane-orange/40 hover:bg-white/[0.07] transition-all duration-300"
            >
              <b.icon className="w-4 h-4 text-smartlane-orange" strokeWidth={2} />
              <span className="font-body text-sm text-white/85">{b.label}</span>
            </div>
          ))}
        </div>
        

      </div>
    </section>
  );
}
